import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import CustomTextInput from "../../../components/CustomTextInput";
import { vocationalInstitutionOwnershipService } from "../../../services/vocational-institution-ownership.service";

export default function VocationalInstitutionOwnershipForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: vocationalInstitutionOwnershipService.findById,
    queryKey: ["vocational-institution-ownership"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: vocationalInstitutionOwnershipService,
    form: form,
    messageApi: messageApi,
    queryKey: "vocational-institution-ownership",
    route: "/master-data/vocational-institution-ownership",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Kepemilikian Lembaga Vokasi"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/vocational-institution-ownership"}
            onClick={form.submit}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Nama"
            name="name"
            rules={[
              {
                required: true,
                message: "Nama harus diisi",
              },
            ]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
